export const DEFAULT_TICKET_PRIORITY = "normal";

export const TICKET_PRIORITIES = [
  { value: "critical", labelKey: "ticket-priority-critical", color: "#C62828", background: "#ffebee" },
  { value: "urgent", labelKey: "ticket-priority-urgent", color: "#EF6C00", background: "#fff3e0" },
  { value: "high", labelKey: "ticket-priority-high", color: "#F9A825", background: "#fff8e1" },
  { value: "normal", labelKey: "ticket-priority-normal", color: "#0066FF", background: "#e3f2fd" },
];

const aliases = {
  critical: "critical",
  urgent: "urgent",
  high: "high",
  normal: "normal",
  1: "critical",
  2: "urgent",
  3: "high",
  4: "normal",
  بحرانی: "critical",
  فوری: "urgent",
  "پر اهمیت": "high",
  عادی: "normal",
};

export function resolveTicketPriority(raw) {
  if (raw == null || raw === "") {
    return DEFAULT_TICKET_PRIORITY;
  }
  const original = String(raw).trim();
  const lower = original.toLowerCase();
  return aliases[lower] || aliases[original] || DEFAULT_TICKET_PRIORITY;
}

export function getTicketPriorityMeta(raw) {
  const value = resolveTicketPriority(raw);
  return (
    TICKET_PRIORITIES.find(function (item) {
      return item.value === value;
    }) || TICKET_PRIORITIES[3]
  );
}

const PRIORITY_RANK = {
  critical: 0,
  urgent: 1,
  high: 2,
  normal: 3,
};

export function getTicketPriorityRank(raw) {
  return PRIORITY_RANK[resolveTicketPriority(raw)];
}
